<template>
  <MenuApp />
  <div class="container">
    <div class="contact">
      <h1>Contactez-nous</h1>
      <p>Vous pouvez nous contactez via : printstationfr@gmail.com</p>
    </div>
  </div>
</template>

<script>
import MenuApp from "./MenuApp.vue";
export default {
  name: "ContactStep",
  components: { MenuApp },
};
</script>

<style scoped>
.contact {
  color: #000;
  max-width: 600px;
  margin: auto;
  padding: 20px;
}
</style>